import { useTranslation } from 'react-i18next';

import { ReactComponent as MailIcon } from './logo-mail.svg';
import { ReactComponent as TelegramLogo } from './logo-telegram.svg';

import './ContactUs.scss';

const ContactUs = () => {
  const { t } = useTranslation();

  return (
    <div className='help-wrapper'>
      <div className='help__content'>
        <a className='help__link' href='https://cryptomus.com/aml' rel='noreferrer' target='_blank'>
          AML Policy
        </a>
        <span className='help__description'>{t('Please contact us if you have any questions')}</span>
        <div className='help__icon-wrapper'>
          <a className='help__icon' href='tg://resolve?domain=cryptomus_support_bot' rel='noreferrer' target='_blank'>
            <TelegramLogo width='44' />
          </a>
          <a className='help__icon' href='mailto:support@cryptomus.com' rel='noreferrer' target='_blank'>
            <MailIcon width='44' />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
